export const cacheKey = 'eventType-isShowViewerCalendar';
